(() => {
  const init = (root) => {
    if (!root || root.dataset.kfReady === 'true') return;
    root.dataset.kfReady = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const items = [...root.querySelectorAll('[data-kf-reveal]')];
    if (!reduceMotion && 'IntersectionObserver' in window) {
      root.classList.add('kf-motion-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      items.forEach((item) => observer.observe(item));
    } else {
      items.forEach((item) => item.classList.add('is-visible'));
    }

    root.querySelectorAll('video[autoplay]').forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      const playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(() => {});
    });
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-kf-home]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
